export default "__VITE_ASSET__0c1836cc__"